import React from 'react';
import PropTypes from 'prop-types';

import Modal from '@zr/components/Modal';
import ResumeUpload from '@zr/components/ResumeUpload';

import './UploadResumeModal.less';

export function UploadResumeModal({
  isOpen, onClose, onStart, onEnd, onError,
  isInJs6650Test,
}) {
  return (
    <Modal
      appElement="#app-platform-generated-screening-questions"
      className={`UploadResumeModal ${isInJs6650Test ? 'js6650' : ''}`}
      isOpen={isOpen}
      onClose={onClose}
    >
      <button
        className="close_button"
        onClick={onClose}
        type="button"
      >
        Close
      </button>
      <div className="warning" />
      <p className="description">Uploading a new resume will replace your existing resume and profile content. Are you sure you want to replace?</p>
      <div className="actions">
        <ResumeUpload
          labelClassName="resume_upload_label"
          onUploadStart={onStart}
          onUploadEnd={onEnd}
          onUploadError={onError}
          text="Yes, Replace"
        />
        <button className="cancel_button" onClick={onClose} type="button">No, do not replace</button>
      </div>
    </Modal>
  );
}

UploadResumeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isInJs6650Test: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onEnd: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onStart: PropTypes.func.isRequired,
};

UploadResumeModal.defaultProps = {
  isInJs6650Test: false,
};

export default UploadResumeModal;
